import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { ResourceFilter } from '../../types/monitoring/resources-filter.type';
import { ResourceSort } from '../../types/monitoring/resource-sort.type';
import { ApiConversionHelper } from '../../helpers/api-conversion.helper';
import { Resource } from '../../types/configuration/resource.type';
import { BulkUpdateResourceModel } from '../../types/bulk-update-resources-model.type';
import { MonitoringProcess, MonitoringQueue } from '../../types/monitoring-configuration.type';

@Injectable({ providedIn: 'root' })
export class MonitoringConfigurationApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/monitoring-configuration`;
  }

  async getRPAProcesses(): Promise<MonitoringProcess[]> {
    return await this.get<MonitoringProcess[]>('processes');
  }

  async updateRPAProcess(process: MonitoringProcess): Promise<void> {
    return await this.put('processes', process);
  }

  async getQueues(): Promise<MonitoringQueue[]> {
    return await this.get<MonitoringQueue[]>('queues');
  }

  async updateQueue(queue: MonitoringQueue): Promise<void> {
    return await this.put('queues', queue);
  }

  async setResourceIsHidden(resourceId: string, isHidden: boolean): Promise<void> {
    return await this.patch(`resources/${resourceId}/is-hidden`, isHidden);
  }

  async getResources(tenantId: string, pageSize: number, pageIndex: number, filter: ResourceFilter = null, sortBy: ResourceSort = null): Promise<Resource[]> {
    const result = await this.get<Resource[]>('resources', { tenantId, pageSize, pageIndex, ...filter, ...sortBy });
    result.forEach(s => ApiConversionHelper.convertMonitoringResource(s));
    return result;
  }

  async bulkAssignResourceToGroups(resourceIds: string[], resourceGroupsIds: string[]): Promise<void> {
    return await this.patch('bulk/resource-groups', { resourceIds, resourceGroupsIds });
  }

  async bulkUpdateResources(resourceIds: string[], isEnabled: boolean | null, isHidden: boolean | null, configuration: BulkUpdateResourceModel): Promise<void> {
    ApiConversionHelper.convertResourceConfigurationForApi(configuration);
    return await this.patch('bulk', { resourceIds, isEnabled, isHidden, configuration });
  }
}
